import { MoreVert as MoreVertIcon } from "components/icon/mui_icon";
import { Divider, IconButton, Stack } from "@mui/material";
import { usePopper } from "hooks";
import { SelectIcon } from "components/icon";
import StyledButton from "customStyled/StyledButton";
import React from "react";

const MoreIcon = ({ children, actionClick = () => null, arr = [],sx = {} }) => {
  const { openPopper, PopperWrapper, handleChange, id } = usePopper({
    closeOnChange: true,
    onChange: (type) => actionClick(type),
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
    sx: {
      left: 24,
    },
  });

  return (
    <>
      <IconButton
        aria-label="actions"
        aria-describedby={id}
        onClick={openPopper}
        sx={{...sx}}
      >
        <MoreVertIcon sx={{color:'#101828'}} />
      </IconButton>
      <PopperWrapper>
        {children}
        <Stack
          sx={{
            gap: 0.5,
            paddingY: 1
          }}>
          {arr.map(
            (
              {
                title,
                value,
                icon,
                color,
                beforeDivider = false,
                afterDivider = false,
              },
              index,
            ) => (
              <React.Fragment key={index}>
                {beforeDivider ? <Divider flexItem /> : null}

                <StyledButton
                  sx={{ justifyContent: "flex-start", marginX: 1, height: 36 }}
                  onClick={() => handleChange(value)}
                  startIcon={SelectIcon({
                    value: icon,
                    // error: color === "error",
                    sx: {
                      color: "inherit",
                    },
                    selected: false,
                  })}
                  color={color}
                  key={index}
                >
                  {title}
                </StyledButton>
                {afterDivider ? <Divider /> : null}
              </React.Fragment>
            ),
          )}
        </Stack>
      </PopperWrapper>
    </>
  );
};

export default MoreIcon;
